import React, { useState, useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Card from "../Card/Card";
import Moment from "moment";
import CardBody from "../Card/CardBody.js";
import CardHeader from "../Card/CardHeader.js";
import styles from "../../../assets/jss/material-dashboard-react/components/customTabsStyle.js";
import { IconButton, Tooltip } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Modal_Frame from "../Modal_Frame";
import CreateActivities from "../../crm/Activities/CreateActivities";
import CreateNotes from "../../crm/Activities/CreateNotes";
import UseFetchData from "../../../hooks/UseFetchData";


let fromDate = new Date().getFullYear() + "/04/01"

const useStyles = makeStyles(styles);

export default function CustomTabs(props) {

  const [FromDate, setFromDate] = useState(fromDate);
  const [defaultfromDate, setdefaultfromDate] = useState(fromDate);
  const [ToDate, setToDate] = useState(new Date());
  const [defaultToDate, setdefaultToDate] = useState(new Date());
  const [value, setValue] = React.useState(0);
  const [isOpen, setOpen] = useState(false);
  const [OpenModel, setOpenModel] = useState(false);
  const [UserID, setUserID] = useState(sessionStorage.UID);
  const [responseDtls, fetchDtlsData] = UseFetchData();
  const handleChange = (event, value) => {
    // debugger;
    setValue(value);
  };

  const classes = useStyles();
  const { headerColor, plainTabs, tabs, title, rtlActive } = props;

  const cardTitle = classNames({
    [classes.cardTitle]: true,
    [classes.cardTitleRTL]: rtlActive,
  });

  const AddNewClick = () => {
    // debugger;
    if (value === 0) {
      setOpen(true);
    }
    else if (value === 1) {
      setOpenModel(true);
    }
  }


  const PopulateData = () => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("UserID", UserID);
    bodyFormData.append("UserType", sessionStorage.UserType);
    bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
    bodyFormData.append("FinacialDate", '');
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    fetchDtlsData("Dashboard/View", bodyFormData);
  }

  useEffect(() => {
    // debugger;
    if (responseDtls.Response === true) {
      props.setOpen(false);
      props.PopulateData();
    }
  }, [responseDtls]);

  return (
    <Card plain={plainTabs}>
      <CardHeader color={headerColor} plain={plainTabs}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {title !== undefined ? <div className={cardTitle}>{title}</div> : null}
          <Tabs
            value={value}
            onChange={handleChange}
            classes={{
              root: classes.tabsRoot,
              indicator: classes.displayNone,
              scrollButtons: classes.displayNone,
            }}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((prop, key) => {
              var icon = {};
              if (prop.tabIcon) {
                icon = {
                  icon: <prop.tabIcon />,
                };
              }
              return (
                <Tab
                  classes={{
                    root: classes.tabRootButton,
                    selected: classes.tabSelected,
                    wrapper: classes.tabWrapper,
                  }}
                  key={key}
                  label={prop.tabName}
                  {...icon}
                />
              );
            })}
          </Tabs>
          <div style={{ width: '50%' }}>
            <div style={{ float: 'right' }}>
              <Tooltip title="Add New">
                <IconButton onClick={() => { AddNewClick(); }} >
                  <AddCircleOutlineIcon style={{ fill: 'white' }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <div style={{ overflow: 'scroll', overflowX: 'hidden', height: 375 }} >
          {tabs.map((prop, key) => {
            if (key === value) {
              return <div key={key}>{prop.tabContent}</div>;
            }
            return null;
          })}
        </div>
      </CardBody>
      <Modal_Frame
        title="Activity Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        < CreateActivities
          setOpen={setOpen}
          DisableUpdate={false}
          DisableComplete={false}
          DisableDelete={true}
          RefDocumentID={UserID}
          pageName={"Dash"}
          // PopulateData={PopulateData}
          Populate={() => props.Populate('')}
          DisableCustomer={false}
          DisableContact={false}
          DisableRefDoc={false}
        />
      </Modal_Frame>
      <Modal_Frame
        title="Note Details"
        maxWidth="xs"
        isOpen={OpenModel}
        setOpen={setOpenModel}
      >
        <CreateNotes
          setNoteOpen={setOpenModel}
          RefDocumentID={UserID}
          pageName={"Dash"}
          // PopulateData={PopulateData}
          Populate={() => props.Populate('')}
        />
      </Modal_Frame>
    </Card>
  );
}

CustomTabs.propTypes = {
  headerColor: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
  ]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string.isRequired,
      tabIcon: PropTypes.object,
      tabContent: PropTypes.node.isRequired,
    })
  ),
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool,
};
